module.exports = __webpack_public_path__ + "img/map_Z3.2.B.03.8d0b99db.svg";